export default function (button, options) {
  // Defaults options.
  const defaultCfg = {
    threshold: 200,
    visibleClass: 'back-to-top--is-visible',
    offset: 0,
    scrollDuration: 500,
  };

  let settings = {};

  init();

  function init() {
    // Merge user's options.
    settings = Object.assign(defaultCfg, options);

    attachEvents();
  }

  function attachEvents() {
    window.addEventListener('scroll', (e) => {
      // Get scroll offset.
      const doc = document.documentElement;
      const scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

      if (scrollTop > settings.threshold) {
        button.classList.add(settings.visibleClass);
      } else {
        button.classList.remove(settings.visibleClass);
      }
    });

    button.addEventListener('click', (e) => {
      e.preventDefault();

      const targetAnchor = button.querySelector('a').getAttribute('href');
      const target = document.getElementById(targetAnchor.substring(1));
      if (!target) {
        throw new Error('Target ID not exists.');
      }

      // Get destination.
      let scrollDestination = target.getBoundingClientRect().top;
      if (settings.offset) {
        scrollDestination -= settings.offset;
      }

      // Smooth.
      window.scroll({
        top: scrollDestination,
        left: 0,
        behavior: 'smooth',
      });
    });
  }
}
